import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var ru = {
  language: 'ru',
  country: 'ru',
  name: 'Русский',
  embeddedLocale: merge(error, login),
  flags: ['RU'],
};

export { ru as default };
